module.exports = __webpack_public_path__ + "assets/img/current-regulation.4e559293.png";